import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';

const SignUpPage = () => (
  <SignUpForm />
);

const INITIAL_STATE = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  isAdmin: true,
  error: null,
};

const ERROR_CODE_ACCOUNT_EXISTS = 'auth/email-already-in-use';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with this E-Mail address already exists.
  Try to login with this account instead. If you think the
  account is already used from one of the social logins, try
  to sign in with one of them. Afterward, associate your accounts
  on your personal account page.
`;

class SignUpFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
    this.props.history.push(ROUTES.AVAILABILITY);
  }

  onSubmit = event => {
    const { username, email, passwordOne, isAdmin } = this.state;
    const roles = {};

    if (isAdmin) {
      roles[ROLES.ADMIN] = ROLES.ADMIN;
    }

    this.props.firebase
      .doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        // Create a user in your Firebase realtime database
        return this.props.firebase.user(authUser.user.uid).set({
          username,
          email,
          roles,
        });
      })
      .then(() => {
        return this.props.firebase.doSendEmailVerification();
      })
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.AVAILABILITY);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    const {
      username,
      email,
      passwordOne,
      passwordTwo,
      isAdmin,
      error,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      username === '';

    return (
      <div className="Container-box">
        <Card className="Card">
          <CardContent>
            <form className="Form-Container" onSubmit={this.onSubmit}>
              <TextField
                className="Text-Field"
                type="text"
                name="username"
                label="Full Name"
                value={username}
                onChange={this.onChange}
                autoComplete="username"
                autoFocus
                required
                margin="normal"
              />
              <TextField
                className="Text-Field"
                type="email"
                name="email"
                label="Email Address"
                value={email}
                onChange={this.onChange}
                autoComplete="email"
                autoFocus
                required
                margin="normal"
              />
              <TextField
                className="Text-Field"
                type="password"
                name="passwordOne"
                label="Password"
                value={passwordOne}
                onChange={this.onChange}
                autoComplete="password"
                autoFocus
                required
                margin="normal"
              />
              <TextField
                className="Text-Field"
                type="password"
                name="passwordTwo"
                label="Confirm Password"
                value={passwordTwo}
                onChange={this.onChange}
                autoComplete="password"
                autoFocus
                required
                margin="normal"
              />
              <label>
                Admin:
                <Checkbox
                  checked={isAdmin}
                  onChange={this.onChangeCheckbox}
                  name="isAdmin" />
              </label>
              <Button variant="contained" size="medium" color="primary" disabled={isInvalid} className="Submit-Button" type="submit">
                Sign Up
              </Button>
              {error && <p>{error.message}</p>}
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const SignUpLink = () => (
  <CardContent className="text-center sign-desc">
    Don't have an account? <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
  </CardContent>
);

const SignUpForm = compose(
  withRouter,
  withFirebase,
)(SignUpFormBase);

export default SignUpPage;

export { SignUpForm, SignUpLink };
